import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ENDPOINTS } from '../../constants/endpoints.constants';
import { Meta } from '../../models/api-response.model';
import { Status } from '../../enums/user-status';

@Injectable({
  providedIn: 'root',
})
export class LookupService {
  http = inject(HttpClient);

  userLookup(data: any) {
    const filterMappings = {
      name: 'filters[search]',
      page: 'page',
      perPage: 'per_page',
      filtersRole: 'filters[role]',
      filtersNotRole: 'filters[not_role]',
      filtersState: 'filters[state]',
      filtersNotId: 'filters[not_id]',
      filtersNotGroup: 'filters[not_group][id]',
      filtersNotState: 'filters[not_states][0]',
      filtersNotStateCancelled: 'filters[not_states][1]',
      filtersNotPermissionForResource:
        'filters[not_permission_for_resource][name]',
      filtersNotPermissionForResourceResourceType:
        'filters[not_permission_for_resource][resource_type]',
      filtersNotPermissionForResourceResourceId:
        'filters[not_permission_for_resource][resource_id]',

      filtersNotPermissionForResourcesResourceType0:
        'filters[not_permissions_for_resources][0][resource_type]',
      filtersNotPermissionForResourcesResourceId0:
        'filters[not_permissions_for_resources][0][resource_id]',
      filtersNotPermissionForResourcesResourceType1:
        'filters[not_permissions_for_resources][1][resource_type]',
      filtersNotPermissionForResourcesResourceId1:
        'filters[not_permissions_for_resources][1][resource_id]',
      filtersNotCollaboratedForFlow: 'filters[not_collaborated_for_flow]',
      filtersNotContributedForStep: 'filters[not_contributed_for_step]',
    };

    let params = new HttpParams();

    Object.entries(filterMappings).forEach(([key, paramName]) => {
      if (data[key]) {
        params = params.append(paramName, data[key]);
      }
    });

    params = params.append('filters[not_states][2]', Status.DELETED);

    const url = ENDPOINTS.Lookup.User;
    return this.http.get<{ data: any; meta: Meta }>(url, { params });
  }
}
